import React from "react";
import { Box, Typography, Button, Container, Grid, Stack, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import logo from "../../../Assets/logo.png";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        background: "linear-gradient(135deg, #f36f21 0%, #e65100 100%)",
        color: "white",
        py: { xs: 8, md: 12 },
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), " +
            "radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.08) 0%, transparent 50%)",
          pointerEvents: "none",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "100px",
          background: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120'%3E%3Cpath d='M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z' fill='%23f5f7fa'/%3E%3C/svg%3E\")",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={6} alignItems="center">
          {/* النص */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                animation: "fadeInUp 0.8s ease-out",
                "@keyframes fadeInUp": {
                  from: { opacity: 0, transform: "translateY(30px)" },
                  to: { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              <Chip
                label="🎉 الحل الأمثل لإدارة مطعمك"
                sx={{
                  mb: 3,
                  background: "rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(10px)",
                  color: "white",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  px: 2,
                  py: 2.5,
                  height: "auto",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                }}
              />

              <Typography
                variant="h2"
                component="h1"
                gutterBottom
                fontWeight={800}
                sx={{
                  fontSize: { xs: "2rem", sm: "2.5rem", md: "3.5rem" },
                  lineHeight: 1.2,
                  mb: 3,
                  textShadow: "0 2px 10px rgba(0,0,0,0.2)",
                }}
              >
                نظام متكامل لإدارة
                <Box
                  component="span"
                  sx={{
                    display: "block",
                    background: "linear-gradient(135deg, #ffffff 0%, #ffe0b2 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                  }}
                >
                  المطاعم والمقاهي
                </Box>
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  mb: 4,
                  lineHeight: 1.8,
                  color: "rgba(255, 255, 255, 0.95)",
                  maxWidth: 550,
                  fontSize: { xs: "1rem", md: "1.25rem" },
                }}
              >
                حل شامل وسهل لإدارة الطلبات، المخزون، الموظفين، والمبيعات.
                ارفع كفاءة مطعمك إلى المستوى التالي! 🚀
              </Typography>

              {/* Features List */}
              <Stack spacing={1.5} sx={{ mb: 4 }}>
                {["إدارة الطلبات بسهولة", "تقارير مبيعات مفصلة", "دعم فني متواصل"].map(
                  (feature, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                      }}
                    >
                      <CheckCircleIcon sx={{ color: "#4ade80", fontSize: 24 }} />
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 500,
                          color: "rgba(255, 255, 255, 0.95)",
                        }}
                      >
                        {feature}
                      </Typography>
                    </Box>
                  )
                )}
              </Stack>

              <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate("/signup")}
                  sx={{
                    fontWeight: 700,
                    px: 5,
                    py: 2,
                    fontSize: "1.1rem",
                    borderRadius: 3,
                    background: "white",
                    color: "#f36f21",
                    textTransform: "none",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
                    "&:hover": {
                      background: "rgba(255, 255, 255, 0.95)",
                      transform: "translateY(-3px)",
                      boxShadow: "0 12px 32px rgba(0, 0, 0, 0.3)",
                    },
                  }}
                >
                  ابدأ مجاناً الآن
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  startIcon={<PlayArrowIcon />}
                  onClick={() => navigate("/about-app")}
                  sx={{
                    fontWeight: 700,
                    px: 4,
                    py: 2,
                    fontSize: "1.1rem",
                    borderRadius: 3,
                    borderWidth: 2,
                    borderColor: "rgba(255, 255, 255, 0.6)",
                    color: "white",
                    textTransform: "none",
                    "&:hover": {
                      borderWidth: 2,
                      borderColor: "white",
                      background: "rgba(255, 255, 255, 0.15)",
                      transform: "translateY(-3px)",
                    },
                  }}
                >
                  شاهد المزيد
                </Button>
              </Stack>
            </Box>
          </Grid>

          {/* الصورة/Mockup */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: "relative",
                animation: "floatAnimation 3s ease-in-out infinite",
                "@keyframes floatAnimation": {
                  "0%, 100%": { transform: "translateY(0)" },
                  "50%": { transform: "translateY(-20px)" },
                },
              }}
            >
              {/* Decorative elements */}
              <Box
                sx={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: { xs: 80, md: 120 },
                  height: { xs: 80, md: 120 },
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                  backdropFilter: "blur(10px)",
                  zIndex: 0,
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: { xs: 100, md: 150 },
                  height: { xs: 100, md: 150 },
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.08)",
                  backdropFilter: "blur(10px)",
                  zIndex: 0,
                }}
              />

              {/* Logo Container - بدون خلفية بيضاء */}
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 5,
                  p: { xs: 4, md: 6 },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1,
                  transition: "all 0.4s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={logo}
                  alt="تطبيق ريستو كاش لإدارة المطاعم"
                  sx={{
                    width: "100%",
                    maxWidth: { xs: 280, sm: 400, md: 500 },
                    height: "auto",
                    filter: "drop-shadow(0 15px 50px rgba(0, 0, 0, 0.5)) drop-shadow(0 8px 24px rgba(255, 255, 255, 0.3))",
                    transition: "all 0.4s ease",
                    "&:hover": {
                      filter: "drop-shadow(0 20px 60px rgba(0, 0, 0, 0.6)) drop-shadow(0 10px 30px rgba(255, 255, 255, 0.4))",
                    },
                  }}
                />

                {/* Glow Effect خلف اللوجو */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: -30,
                    borderRadius: "50%",
                    background: "radial-gradient(circle at center, rgba(255, 255, 255, 0.4), transparent 60%)",
                    filter: "blur(40px)",
                    zIndex: -1,
                    opacity: 0.8,
                  }}
                />

                {/* Animated Ring */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: -20,
                    borderRadius: "50%",
                    border: "3px solid rgba(255, 255, 255, 0.3)",
                    animation: "rotate 20s linear infinite",
                    "@keyframes rotate": {
                      from: { transform: "rotate(0deg)" },
                      to: { transform: "rotate(360deg)" },
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: -10,
                      left: "50%",
                      width: 20,
                      height: 20,
                      borderRadius: "50%",
                      background: "rgba(255, 255, 255, 0.8)",
                      boxShadow: "0 0 20px rgba(255, 255, 255, 0.8)",
                    },
                  }}
                />
              </Box>

              {/* Floating badge */}
              <Box
                sx={{
                  position: "absolute",
                  top: { xs: 15, md: 20 },
                  left: { xs: 15, md: 20 },
                  background: "rgba(255, 255, 255, 0.95)",
                  backdropFilter: "blur(15px)",
                  borderRadius: 3,
                  px: { xs: 2, md: 3 },
                  py: { xs: 1.5, md: 2 },
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
                  border: "2px solid rgba(255, 255, 255, 0.5)",
                  zIndex: 3,
                  animation: "pulse 2s ease-in-out infinite",
                  "@keyframes pulse": {
                    "0%, 100%": { transform: "scale(1)" },
                    "50%": { transform: "scale(1.05)" },
                  },
                }}
              >
                <Typography 
                  variant="body2" 
                  fontWeight={700} 
                  sx={{ 
                    color: "#f36f21",
                    fontSize: { xs: "0.875rem", md: "1rem" },
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5
                  }}
                >
                  ⭐ 500+ مطعم يثق بنا
                </Typography>
              </Box>

              {/* Additional Feature Badges */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: { xs: 15, md: 20 },
                  right: { xs: 15, md: 20 },
                  display: "flex",
                  gap: 1,
                  flexWrap: "wrap",
                  zIndex: 3,
                }}
              >
                <Chip
                  label="✓ سهل الاستخدام"
                  sx={{
                    background: "rgba(76, 175, 80, 0.95)",
                    color: "white",
                    fontWeight: 600,
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    backdropFilter: "blur(10px)",
                  }}
                />
                <Chip
                  label="✓ آمن"
                  sx={{
                    background: "rgba(33, 150, 243, 0.95)",
                    color: "white",
                    fontWeight: 600,
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    backdropFilter: "blur(10px)",
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default HeroSection;
